import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DistrictDashboard from './pages/DistrictDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard/:districtId" element={<DistrictDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
